// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignRightOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignRightOutlined";
import AntdIcon from '../components/AntdIcon';

var AlignRightOutlined = function AlignRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignRightOutlinedSvg
  }));
};

AlignRightOutlined.displayName = 'AlignRightOutlined';
export default /*#__PURE__*/React.forwardRef(AlignRightOutlined);